import dayjs from "dayjs";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { SelectField } from "../../../core/select-field.component";
import { useGetRoute } from "../../../apiclient/master/useGetRouteApi";
import DatePicker from "react-datepicker";
import { formatDate } from "@progress/kendo-intl";
import { useGetSessions } from "../../../apiclient/master/useGetSessionApi";
import { getDataWithToken, getEndPoint, postData } from "../../../Utils/network.client";
import { API_END_POINT } from "../../../constants";
import { Grid, GridColumn as Column, GridItemChangeEvent } from "@progress/kendo-react-grid";
import DispatchEntryPage from "./dispatch-entry";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { ProductList } from "../../../models/transaction/dispatch-model";
// import { Popup } from "@progress/kendo-react-popup";
// import EditIcon from "../../../assets/images/edit";

export const Dispatch = () => {
    const [fromDate1, setFromDate] = useState<Date>(new Date(dayjs().format("MM/DD/YYYY")));
    const [routeData, setRouteData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedRoute } = useGetRoute();
    const [routeid, setRouteId] = useState<any>(null);
    const [sessionData, setSessionData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedSession } = useGetSessions();
    const [sessionid, setSessionId] = useState<any>(null);
    const [gridColumns, setGridColumns] = useState<any[]>([]);
    const [gridData, setGridData] = useState<any[]>([]);
    const [showEntryModal, setShowEntryModal] = useState(false);
    const [selectedData, setSelectedData] = useState<any>(null);
    const [expandedRows, setExpandedRows] = useState<any>({});
    // const [popupVisible, setPopupVisible] = useState(false);
    // const [popupAnchor, setPopupAnchor] = useState<HTMLElement | null>(null);
    // const [editingProduct, setEditingProduct] = useState<any>(null);
    // const [editingParentId, setEditingParentId] = useState<number | null>(null);

    /*  const [productList, setProductList] = useState<productList[]>([]); */

    const [productList, setProductList] = useState<ProductList[]>([]);



    useEffect(() => {
        if (fetchedRoute) {
            const mappedRoute = fetchedRoute.map((route: any) => ({
                value: route.routeId,
                label: route.name,
            }));
            setRouteData(mappedRoute);
        }
    }, [fetchedRoute]);

    useEffect(() => {
        if (fetchedSession) {
            const mappedSession = fetchedSession
                .filter((session: any) => session.name.trim().toLowerCase() !== "both")
                .map((session: any) => ({
                    value: session.sessionId,
                    label: session.name,
                }));
            setSessionData(mappedSession);
        }
    }, [fetchedSession]);

    const handleRouteChange = (value: any) => {
        setRouteId(value);
    };

    const handleDateChange = (value: any) => {
        setFromDate(value);
    };

    const handleSessionChange = (value: any) => {
        setSessionId(value);
    };

    const getroutewisedispatch = async () => {
        try {
            const response = await getDataWithToken<any>(
                `${getEndPoint(API_END_POINT.ORDER)}/api/Dispatch/GetDispatchByDateShiftRoute/${dayjs(fromDate1).format(
                    "YYYY-MM-DD"
                )}/${sessionid}/${routeid}`
            );

            const parsedResponse = JSON.parse(response.data.result);

            const headers = parsedResponse.header?.[0] || {};
            const details = Array.isArray(parsedResponse.details) ? parsedResponse.details : [];

            if (details.length === 0) {
                setGridColumns([]);
                setGridData([]);
                return;
            }

            const columns = Object.keys(headers).map((key) => ({
                field: key,
                title: headers[key],
            }));

            const grouped = details.map((item: any, index: number) => ({
                id: index,
                col1: item.col1,
                col2: item.col2,
                col3: item.col3,
                col4: item.col4,
                col5: item.col5,
                col6: item.col6,
                col7: item.col7,
                col8: item.col8,
                col9: item.col9,
                col10: item.col10,
                col11: item.col11,
                col12: item.col12,
                col13: item.col13,
                col14: item.col14,
                // products: item.products || [],
                products: (item.products || []).map((p: any) => ({
                    ...p,
                    qty: String(p.qty)  // 👈 convert Qty to string
                })),
                inEdit: true,
            }));

            setProductList(grouped[0].products);

            console.log("g", grouped[0].products);
            setGridColumns(columns);
            setGridData(grouped);
        } catch (error) {
            console.error("Error fetching data:", error);
        }


    };


    console.log("productList", productList);

    // const handleEditClick = (dataItem: any) => {
    //     setSelectedData({
    //         ...dataItem,
    //         droppingPointId: dataItem.col1,
    //         selectedDate: fromDate1,
    //         routeId: routeid,
    //         sessionId: sessionid,
    //     });
    //     setShowEntryModal(true);
    // };

    const handleSave = async (dataItem: any) => {
        const updatedData = {
            ...dataItem,
            droppingPointId: dataItem.col1,
            selectedDate: fromDate1,
            routeId: routeid,
            sessionId: sessionid,
        };

        try {
            // Call your API here

            const response = await postData<any>(API_END_POINT.ORDER,
                "Dispatch/SaveDispatch",
                "POST",
                "application/json",
                { products: updatedData.products },
            );



            console.log(response);

            // Optionally update state or show confirmation
            // setSelectedData(updatedData);
            // setShowEntryModal(true); // show modal if still needed after save
        } catch (error) {
            console.error('Error saving data:', error);
            alert('Error saving data. Please try again.');
        }
    };


    const handleCloseEntryPage = () => {
        setSelectedData(null);
        setShowEntryModal(false);
    };



    const handleDetailItemChange = (e: GridItemChangeEvent, parentId: number) => {
        const { dataItem, field, value } = e;

        dataItem[field] = value;

        if (field === "qty") {
            dataItem.Amount = value * dataItem.rate;
            dataItem.TotalAmount = value * dataItem.rate;

             const updatedData = [...gridData];
        const parentIndex = updatedData.findIndex(item => item.id === parentId);

        if (parentIndex !== -1) {
            const products = updatedData[parentIndex].products;

            // Recalculate totals
            const totalAmount = products.reduce((sum: number, p: any) => sum + (parseFloat(p.Amount) || 0), 0);
            const totalTax = products.reduce((sum: number, p: any) => sum + (parseFloat(p.TaxAmount) || 0), 0);
            const totalWithTax = products.reduce((sum: number, p: any) => sum + (parseFloat(p.TotalAmount) || 0), 0);

            // Update parent grid values
            updatedData[parentIndex].col9 = totalAmount; // Amount
            updatedData[parentIndex].col11 = totalWithTax; // Total or Net Amount

            setGridData(updatedData);
        }
        }
    };

    const handleRowClick1 = (event: any, parentId: number) => {
        const updatedData = [...gridData];
        const parentIndex = updatedData.findIndex(item => item.id === parentId);

        if (parentIndex !== -1) {
            const updatedProducts = updatedData[parentIndex].products.map((product: { productId: any; }) => ({
                ...product,
                inEdit: product.productId === event.dataItem.productId
            }));
            updatedData[parentIndex].products = updatedProducts;
            setGridData(updatedData);
        }
    };



    return (
        <Formik
            initialValues={{ routeId: "", fromDate: fromDate1, sessionId: "" }}
            onSubmit={(values) => {
                console.log("Form submitted with values: ", values);
            }}
        >
            {() => (
                <Form>
                    <div className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15" style={{ minHeight: "500px" }}>
                        <div className="top-sec-align row">
                            <center>
                                <h4 className="text-normal title-web mb-0 report-title-color">Dispatch Details</h4>
                            </center>

                            {!showEntryModal && (
                                <div className="d-flex mt-4">
                                    <div className="me-2">
                                        <label>Select Date</label>
                                        <DatePicker
                                            className="form-control w-25 ms-auto search-right-align calendarBg"
                                            selected={fromDate1}
                                            dateFormat={"dd/MM/yyyy"}
                                            onChange={(date: Date) => {
                                                setFromDate(date);
                                                handleDateChange(date);
                                            }}
                                        />
                                    </div>
                                    <div className="me-2">
                                        <label>Select Session</label>
                                        <SelectField name="sessionId" options={sessionData} unSelectValue={0} notifyChange={handleSessionChange} />
                                    </div>
                                    <div className="me-2">
                                        <label>Select Route</label>
                                        <SelectField name="routeId" options={routeData} unSelectValue={0} notifyChange={handleRouteChange} />
                                    </div>
                                    <div className="col-md-3 mb-2 d-flex align-items-start pt-3">
                                        <label>&nbsp;</label>
                                        <button
                                            className="btn btn-primary search-btn w-50 mt-1"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                getroutewisedispatch();
                                            }}
                                            type="submit"
                                        >
                                            <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                                                <path
                                                    d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                                                    fill="#fff"
                                                />
                                            </svg>
                                            &nbsp;
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {showEntryModal ? (
                            <DispatchEntryPage data={selectedData} onClose={handleCloseEntryPage} />
                        ) : (
                            <>
                                {gridData.length > 0 && (
                                    <div className="mt-4">
                                        <Grid
                                            data={gridData.map((item) => ({
                                                ...item,
                                                expanded: expandedRows[item.id] || false,
                                            }))}
                                            resizable={true}
                                            detail={(props) => {
                                                const parentId = props.dataItem.id;
                                                const products = props.dataItem.products;

                                                return (
                                                    <Grid
                                                        data={products}
                                                        onRowClick={(e) => {
                                                            handleRowClick1(e, parentId)
                                                        }}

                                                        editField="inEdit"
                                                        onItemChange={(e) => handleDetailItemChange(e, parentId)}

                                                    >
                                                        <Column title="S.No" width={60} cell={(props) => <td>{props.dataIndex + 1}</td>} />
                                                        <Column field="Code" title="Code" width={60} editable={false} />
                                                        <Column field="product" title="Product" editable={false} />
                                                        <Column field="Unit" title="Unit" editable={false} />
                                                        <Column
                                                            field="rate"
                                                            title="Rate"
                                                            headerClassName="right-align-header1"
                                                            cell={(props) => (
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {props.dataItem.rate != null ? props.dataItem.rate.toFixed(3) : ''}
                                                                </td>
                                                            )}
                                                            editable={false}
                                                        />
                                                        <Column

                                                            field="qty"
                                                            title="Quantity"
                                                            editor="numeric"
                                                            editable={true}
                                                            width={100}

                                                        />

                                                        <Column
                                                            field="Amount"
                                                            title="Amount"
                                                            headerClassName="right-align-header1"
                                                            cell={(props) => <td style={{ textAlign: 'right' }}>
                                                                {props.dataItem.Amount != null ? props.dataItem.Amount.toFixed(2) : ''}
                                                            </td>}
                                                            editable={false}
                                                        />
                                                        <Column
                                                            field="TaxAmount"
                                                            title="Tax"
                                                            headerClassName="right-align-header1"
                                                            cell={(props) =>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {props.dataItem.TaxAmount != null ? props.dataItem.TaxAmount.toFixed(2) : ''}
                                                                </td>}
                                                            editable={false}
                                                        />
                                                        <Column
                                                            field="TotalAmount"
                                                            title="Total"
                                                            headerClassName="right-align-header1"
                                                            cell={(props) => <td style={{ textAlign: 'right' }}>
                                                                {props.dataItem.TotalAmount != null ? props.dataItem.TotalAmount.toFixed(2) : ''}
                                                            </td>}
                                                            editable={false}
                                                        />
                                                        <Column
                                                            field="Commission"
                                                            title="Commission"
                                                            cell={(props) => <td style={{ textAlign: 'right' }}>
                                                                {props.dataItem.Commission != null ? props.dataItem.Commission.toFixed(2) : ''}
                                                            </td>}
                                                            editable={false}
                                                        />
                                                        {/* <Column
                                                            title="Actions"
                                                            cell={(props) => (
                                                                <td>
                                                                    <button style={{ width: "5px" }}
                                                                        className="action-btns k-grid-edit-command"
                                                                        onClick={(e) => {
                                                                            setEditingProduct(props.dataItem);
                                                                            setEditingParentId(parentId);
                                                                            setPopupAnchor(e.currentTarget);
                                                                            setPopupVisible(true);
                                                                        }}
                                                                    >
                                                                        <EditIcon></EditIcon>
                                                                    </button>
                                                                </td>
                                                            )}
                                                        /> */}
                                                    </Grid>
                                                );
                                            }}
                                            expandField="expanded"
                                            onExpandChange={(e) => {
                                                setExpandedRows((prev: any) => ({
                                                    ...prev,
                                                    [e.dataItem.id]: e.value,
                                                }));
                                            }}
                                        >
                                            <Column title="S.No" width={60} cell={(props) => <td>{props.dataIndex + 1}</td>} />

                                            {gridColumns
                                                .filter((col) => col.field !== 'col15')
                                                .map((col) => {
                                                    const isRightAligned = ["col7", "col8", "col9", "col10", "col11", "col12", "col13", "col14"].includes(col.field);
                                                    return (
                                                        <Column
                                                            key={col.field}
                                                            field={col.field}
                                                            title={col.title}
                                                            headerClassName={isRightAligned ? "text-end" : undefined}
                                                            cell={isRightAligned ? (props) => (
                                                                <td style={{ textAlign: 'right' }}>{props.dataItem[col.field].toFixed(2)}</td>
                                                            ) : undefined}
                                                        />
                                                    );
                                                })}
                                            <Column

                                                cell={(props) => (
                                                    <td>
                                                        <button className="btn btn-sm btn-primary"
                                                            onClick={() => handleSave(props.dataItem)}>
                                                            Save
                                                        </button>
                                                    </td>
                                                )}
                                            />
                                        </Grid>
                                    </div>


                                )}

                                {/* {popupVisible && editingProduct && (
                                    <Popup

                                        show={popupVisible}
                                        popupClass="popup-edit-form"
                                        onClose={() => setPopupVisible(false)}
                                    >
                                        <div className="popup-content p-3 bg-white shadow radius-10" style={{ minWidth: 250 }}>
                                            <h5><center>{editingProduct.product}</center></h5>
                                            <div className="mb-2">
                                                <label>Qty</label>
                                                <NumericTextBox
                                                    value={editingProduct.qty}
                                                    onChange={(e) => {
                                                        setEditingProduct((prev: any) => ({
                                                            ...prev,
                                                            qty: e.value,
                                                            Amount: e.value * prev.rate,
                                                        }));
                                                    }}
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label>Rate</label>
                                                <NumericTextBox
                                                    value={editingProduct.rate}
                                                    disabled
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label>Amount</label>
                                                <NumericTextBox value={editingProduct.Amount} disabled />
                                            </div>
                                            <div className="d-flex justify-content-end mt-3">
                                                <button
                                                    className="btn btn-sm btn-secondary me-2"
                                                    onClick={() => setPopupVisible(false)}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => {
                                                        const updatedGridData = [...gridData];
                                                        const parentIndex = updatedGridData.findIndex(item => item.id === editingParentId);
                                                        if (parentIndex !== -1) {
                                                            const productIndex = updatedGridData[parentIndex].products.findIndex(
                                                                (p: { productId: any; }) => p.productId === editingProduct.productId
                                                            );
                                                            if (productIndex !== -1) {
                                                                updatedGridData[parentIndex].products[productIndex] = editingProduct;
                                                                setGridData(updatedGridData);
                                                            }
                                                        }
                                                        setPopupVisible(false);
                                                        setEditingProduct(null);
                                                        setEditingParentId(null);
                                                    }}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </Popup>
                                )} */}

                            </>
                        )}
                    </div>
                </Form>
            )}
        </Formik>
    );
};
